module.exports = __webpack_public_path__ + "images/facebook@1x.png?8957ba69";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook@1x.png
// module id = 621
// module chunks = 7